<template>
  <div class="main">
    <div class="bg-img-all">
      <div class="download-button-sty" @click="download_apk"></div>
      <!-- <div class="finger"></div> -->
    </div>
  </div>
</template>

<script>
import { download, chnup, loadPage } from "../utils/tools";

export default {
  data() {
    return {};
  },
  methods: {
    download_apk: function (event) {
      chnup("click");
      download();
      this.showTgReward();
    },
    tgOpenTop(track) {
      chnup(track);
      window.open("https://t.me/+-O7J81YvCptjZTg9");
    },
    goFaceBook() {
      chnup("fbch_click_view");
      window.open("https://www.facebook.com/happyacerummypage");
    },
    goWhatsapp() {
      chnup("wach_click_view");
      window.open("https://whatsapp.com/channel/0029VaiGFuAG3R3ZhMZOQ001");
    },
    tgOpenBottom() {
      chnup("tgch_click_view_bottom");
      window.open("https://t.me/+-O7J81YvCptjZTg9");
    },
    clickTrack: function (msg) {
      if (msg == "stepPict1" || msg == "bannerClick1") {
        chnup(msg);
        return;
      }
    },
    showTgReward() {
      setTimeout(() => {
        var element = document.getElementById("tgReward");
        element.classList.remove("tg_reward_box_hidden");
        element.classList.add("tg_reward_box_show");
      }, 6000);
    },
    closeTgRewardBox() {
      var element = document.getElementById("tgReward");
      element.classList.remove("tg_reward_box_show");
      element.classList.add("tg_reward_box_hidden");
    },
  },
  created() {
    loadPage();
  },
};
</script>

<style lang="less" scoped>
.main {
  background: #fff;
  height: 100vh;
  width: 100vw;
}
.bg-img-all {
  width: 100vw;
  height: 177.78vw;
  background-image: url("../../static/mobileb/bg.png");
  background-size: cover;
  position: relative;
}
.download-button-sty {
  position: absolute;
  top: 95.69vw;
  left: 10.32vw;
  width: 80.19vw;
  height: 15.33vw;
  background-image: url("../../static/mobileb/download.png");
  background-size: cover;
  animation-name: scaleDraw;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 1s;
}

@keyframes scaleDraw {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1.1);
  }
  75% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageB.vue